<div class="row">
    <div class="col-12">

        <!-- <div class="card"> -->
            <!-- <div class="card-header">
                <div class="title">{{ 'MENU_SIDEBAR.SETTINGS' | translate }}</div>
                <div class="tools"></div>
            </div> -->
            <div class="card-body">

                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a class="nav-link active" id="nav-roles-tab" [ngClass]="{'active': switchTab === 'roles'}" data-toggle="tab" href="#nav-roles" role="tab" aria-controls="nav-roles" aria-selected="true">{{ 'ROLES' | translate }}</a>
                      <a class="nav-link" id="nav-attributes-tab" [ngClass]="{'active': switchTab === 'attributes'}" data-toggle="tab" href="#nav-attributes" role="tab" aria-controls="nav-attributes" aria-selected="true">{{ 'ATTRIBUTES.ATTRIBUTES' | translate }}</a>
                      <a class="nav-link" id="nav-categories-tab" [ngClass]="{'active': switchTab === 'categories'}" data-toggle="tab" href="#nav-categories" role="tab" aria-controls="nav-categories" aria-selected="true">{{ 'CATEGORIES' | translate }}</a>
                      <a class="nav-link" id="nav-notificattions-tab" [ngClass]="{'active': switchTab === 'notificattions'}" data-toggle="tab" href="#nav-notificattions" role="tab" aria-controls="nav-notificattions" aria-selected="true">{{ 'NOTICE' | translate }}</a>
                      <!-- <a class="nav-link" id="nav-org-structure-tab" [ngClass]="{'active': switchTab === 'org-structure'}" data-toggle="tab" href="#nav-org-structure" role="tab" aria-controls="nav-org-structure" aria-selected="true">{{ 'ORGANIZATION.ORGANIZATION_STRUCTURE' | translate }}</a> -->
                      <!-- <a class="nav-link" id="nav-validators-tab" [ngClass]="{'active': switchTab === 'validators'}" data-toggle="tab" href="#nav-validators" role="tab" aria-controls="nav-validators" aria-selected="true">{{ 'VALID' | translate }}</a> -->
                      <!-- <a class="nav-link" id="nav-subscriptions-tab" [ngClass]="{'active': switchTab === 'subscriptions'}" data-toggle="tab" href="#nav-subscriptions" role="tab" aria-controls="nav-subscriptions" aria-selected="true">{{ 'SUBSC.SUBSCRIPTIONS' | translate }}</a> -->
                      <a class="nav-link" id="nav-specifications-tab" [ngClass]="{'active': switchTab === 'specifications'}" data-toggle="tab" href="#nav-specifications" role="tab" aria-controls="nav-specifications" aria-selected="true"> Спецификации</a>
                      <a *ngIf="checkRole" class="nav-link" id="nav-customers-integration-tab" [ngClass]="{'active': switchTab === 'customers-integration'}" data-toggle="tab" href="#nav-customers-integration" role="tab" aria-controls="nav-customers-integration" aria-selected="true"> Интеграция</a>
                    </div>
                </nav>

                    <div class="tab-content" id="nav-tabContent">

                        <!-- ROLES -->
                        <div class="tab-pane fade show active" id="nav-roles" [ngClass]="{'show active': switchTab === 'roles'}" role="tabpanel" aria-labelledby="nav-roles-tab">

                            <app-user-org-roles></app-user-org-roles>

                        </div>

                        <!-- ATTRIBUTES -->
                        <div class="tab-pane fade" id="nav-attributes" [ngClass]="{'show active': switchTab === 'attributes'}" role="tabpanel" aria-labelledby="nav-attributes-tab">

                            <!-- <div class="nav-buttons">
                                <button type="button" class="btn btn-outline btn-sm" *ngFor="let item of categoriesComponents" (click)="getComponent(item.id)">{{ item.name[language] }}</button>
                            </div> -->

                            <div class="tabs">

                                <input type="radio"  name="tab-btn" id="tab-btn-1" value="" checked>
                                    <label  class="btn btn-outline btn-sm tab-btn" for="tab-btn-1">{{ 'ATTRIBUTES.ATTRIBUTES' | translate }}</label>

                                <input type="radio" name="tab-btn" id="tab-btn-2" value="">
                                    <label   class="btn btn-outline btn-sm tab-btn"for="tab-btn-2">{{ 'DIALOG.GROUPS.GROUP_ATTRIBUTE' | translate }}</label>

                                <input type="radio" name="tab-btn" id="tab-btn-3" value="">
                                    <label  class="btn btn-outline btn-sm tab-btn" for="tab-btn-3">{{ 'REFERENCE.REFERENCES' | translate }} </label>

                                <!-- ATTRIBUTES -->
                                <div id="content-1">
                                    <app-attributes-list></app-attributes-list>
                                </div>
                                <!-- ATTRIBUTES-GROUPS -->
                                <div id="content-2">
                                    <app-attributes-groups-list></app-attributes-groups-list>
                                </div>
                                <!-- REFERENCES -->
                                <div id="content-3">
                                    <app-references-list></app-references-list>
                                </div>
                            </div>


                            <!-- V.2 -->
                            <!-- ATTRIBUTES
                            <div id="nav-attributes" *ngIf="switchTabAttr === 'attributes'">
                                <app-attributes-list></app-attributes-list>
                            </div>
                            ATTRIBUTES-GROUPS
                            <div id="nav-attributes-groups" *ngIf="switchTabAttr === 'attributes-groups'">
                                <app-attributes-groups-list></app-attributes-groups-list>
                            </div>
                            REFERENCES
                            <div id="nav-references" *ngIf="switchTabAttr === 'references'">
                                <app-references-list></app-references-list>
                            </div> -->
                            
                            <!-- <app-presets-list *ngIf="condition == 'presets'"></app-presets-list> -->

                        </div>

                        <!-- CATEGORY -->


 


                        <div class="tab-pane fade" id="nav-categories" [ngClass]="{'show active': switchTab === 'categories'}" role="tabpanel" aria-labelledby="nav-categories-tab">

                            <!-- <div class="nav-buttons">
                                <button type="button" class="btn btn-outline btn-sm" *ngFor="let item of categoriesComponents" (click)="getComponent(item.id)">{{ item.name[language] }}</button>
                            </div>

                            <app-tree-view *ngIf="condition == 'categories'" [header]="treeHeader" [categoryType]="condition"></app-tree-view>
                            <app-tree-view *ngIf="condition == 'files_categories'" [header]="treeHeader" [categoryType]="condition"></app-tree-view> -->

                            <div class="tabs-category">

                                <input type="radio"  name="tab-btn-category" id="tab-btn-category-1" value="" checked>
                                    <label  class="btn btn-outline btn-sm tab-btn" for="tab-btn-category-1">Список категорий</label>
    
                                <input type="radio" name="tab-btn-category" id="tab-btn-category-2" value="">
                                    <label   class="btn btn-outline btn-sm tab-btn"for="tab-btn-category-2">Список файловых категорий</label>
    
                                <!-- categories -->
                                <div id="content-category-1">
                                    <app-tree-view [header]="treeHeader" [categoryType]="'categories'"></app-tree-view>
                                </div>
                                <!-- files_categories -->
                                <div id="content-category-2">
                                    <app-tree-view [header]="treeHeader" [categoryType]="'files_categories'"></app-tree-view>
                                </div>
                            </div>

                        </div>
                        
                        <!-- NOTIFICATIONS -->
                        <div class="tab-pane fade" id="nav-notificattions"[ngClass]="{'show active': switchTab === 'notificattions'}" role="tabpanel" aria-labelledby="nav-notificattions-tab">

                            
                            <!-- <div class="nav-buttons">
                                <button type="button" class="btn btn-outline btn-sm" *ngFor="let item of notificationComponents" (click)="getComponent(item.id)">{{ item.name[language] }}</button>
                            </div> -->

                            <app-notifications-roles-settings></app-notifications-roles-settings>
                            <!-- <app-notifications-channel-settings *ngIf="condition == 'channel_notifications'"></app-notifications-channel-settings> -->
        
                        </div>
                            
                        <!-- ORGS POS/DEP/SRTUCTURE -->
                        <!-- <div class="tab-pane fade" id="nav-org-structure"[ngClass]="{'show active': switchTab === 'org-structure'}" role="tabpanel" aria-labelledby="nav-org-structure-tab">
                            
                            <div class="nav-buttons">
                                <button type="button" class="btn btn-outline btn-sm" *ngFor="let item of orgStructureComponents" (click)="getComponent(item.id)">{{ item.name[language] }}</button>
                            </div>

                            <app-employee-positions *ngIf="condition == 'positions'"></app-employee-positions>
                            <app-departments-list *ngIf="condition == 'depatrments'"></app-departments-list>
                            <app-structures-list *ngIf="condition == 'structures'"></app-structures-list>

                        </div> -->

                        <!-- VALIDATORS -->
                        <!-- <div class="tab-pane fade" id="nav-validators"[ngClass]="{'show active': switchTab === 'validators'}" role="tabpanel" aria-labelledby="nav-validators-tab">

                           <app-attributes-validator-list></app-attributes-validator-list>

                        </div> -->

                        <!-- SUBSCRIPTIONS -->
                        <div class="tab-pane fade" id="nav-subscriptions"[ngClass]="{'show active': switchTab === 'subscriptions'}" role="tabpanel" aria-labelledby="nav-subscriptions-tab">

                            <app-subscriptions-list></app-subscriptions-list>

                        </div>

                        <!-- SPECIFICATIONS -->
                        <div class="tab-pane fade" id="nav-specifications"[ngClass]="{'show active': switchTab === 'specifications'}" role="tabpanel" aria-labelledby="nav-specifications-tab">

                            <app-specifications-list></app-specifications-list>

                        </div>

                        <!-- CUSTOMER INTEGRATION -->
                        <div *ngIf="checkRole" class="tab-pane fade" id="nav-customers-integration" [ngClass]="{'show active': switchTab === 'customers-integration'}" role="tabpanel" aria-labelledby="nav-customers-integration-tab">

                            <app-customers-integration></app-customers-integration>

                        </div>

                    </div>

            </div>
        <!-- </div> -->

    </div>
</div>